import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getLiveQuestion, getMyVote, getVoteResults, castVote } from '@/services/api/questions'

export function useLiveQuestion(enabled = true) {
  return useQuery({
    queryKey: ['questions', 'live'],
    queryFn: getLiveQuestion,
    enabled,
    retry: false,
  })
}

export function useMyVote(questionId: string | undefined) {
  return useQuery({
    queryKey: ['questions', questionId, 'my-vote'],
    queryFn: () => getMyVote(questionId!),
    enabled: !!questionId,
    retry: false,
  })
}

export function useVoteResults(questionId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['questions', questionId, 'results'],
    queryFn: () => getVoteResults(questionId!),
    enabled: !!questionId && enabled,
  })
}

export function useCastVote() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ questionId, optionId }: { questionId: string; optionId: string }) =>
      castVote(questionId, optionId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['questions', variables.questionId, 'my-vote'] })
      queryClient.invalidateQueries({ queryKey: ['questions', variables.questionId, 'results'] })
    },
  })
}
